import { max } from "../math";
var sessionValue = 0;
var sessionEntries = [];
var maximumSessionValue = 0;
export function addEntry(entry) {
    if (!entry.hadRecentInput) {
        var firstEntry = sessionEntries[0];
        var latestEntry = sessionEntries[sessionEntries.length - 1];
        if (sessionEntries.length &&
            (entry.startTime - latestEntry.startTime >= 1000 ||
                entry.startTime - firstEntry.startTime >= 5000)) {
            sessionValue = entry.value;
            sessionEntries = [entry];
        }
        else {
            sessionValue += entry.value;
            sessionEntries.push(entry);
        }
        maximumSessionValue = max(maximumSessionValue, sessionValue);
    }
}
export function reset() {
    sessionValue = 0;
    sessionEntries = [];
    maximumSessionValue = 0;
}
export function getCLS() {
    return maximumSessionValue;
}
